var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"regen-templates-list-expand"},[_c('Tableview',{attrs:{"fields":_vm.tableHeaders,"loading":_vm.loading,"items":_vm.items,"displayFilterActions":false},on:{"saved":_vm.getTableData}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }